import { useEffect, useState } from 'react';
import { GetLeaderDashboardTransactionBasedUserService } from '../../services/DashboardServices';
import DashboardMenu from './DashboardMenu';
import { useLocation } from 'react-router-dom';
import moment from 'moment';
import { DatePicker } from 'antd';
import { FiChevronRight, FiChevronLeft } from 'react-icons/fi';
import { IconButton } from '@material-ui/core';
import { ButtonFilledAutoWidth, ButtonOutlinedAutoWidth } from '../../components/button';
import { AiOutlineEdit } from 'react-icons/ai';

function LeaderBoardTransaction() {

  const {state} = useLocation()

  const [search,setsearch] = useState({text:'',from_date:'',from_date1:'',to_date:'',to_date1:''})
  const [data,setdata] = useState([])
  const [page,setpage] = useState(1)

  useEffect(()=>{
    getData()
  },[state,page])

  async function getData() {
    const response = await GetLeaderDashboardTransactionBasedUserService(state?.user?._id,search?.text,search?.from_date1,search?.to_date1,page)
    setdata(response?.data)
  }

  async function applyFilter() {
    
  }

  async function resetfilter() {
    
  }


  console.log("data",data)

  return (
    <div className='w-[98%] md:h-screen md:overflow-hidden'>

     

      <div className='md:flex items-start'>
          <DashboardMenu />
        <div className='md:w-[90%] pl-5 pt-4'>
        
           <div className='md:flex items-center -mt-1 border-b justify-between pb-1'>
            <div className='flex items-center justify-between'>
            <h6 className='font-[800] text-[13px]'>{state?.user?.name} - Points ({state?.points}) - Total ({data?.pagination?.total})</h6>
            <div className='flex md:hidden items-center text-[12px]'>
              {/* <AiOutlineFileExcel onClick={() => downloaddata()} size={24} className='mx-2 bg-gray-200 p-1.5' /> */}
              
              <div className='hidden md:block'>
              <h6 className='mr-2 font-[600]'>{page == 1 ? data?.datas?.length > 0 ? 1 : 0 : (page - 1) * data?.pagination?.limit} - {data?.pagination?.limit} of {data?.pagination?.total}  </h6>

              <div>
                <IconButton onClick={() => { page > 1 ? setpage(page - 1) : console.log('') }}><FiChevronLeft className={`${page === 1 ? 'opacity-50' : 'opacity-100'}`} size={16} /></IconButton>
                <IconButton onClick={() => { page < data?.pagination?.totalPages ? setpage(page + 1) : console.log('') }}><FiChevronRight className={`${(data?.pagination?.totalPages === page || data?.datas?.length === 0) ? 'opacity-50 ' : 'opacity-100'}`} size={16} /></IconButton>
              </div>
              </div>
            </div>
            </div>

              <div className='block flex items-center md:hidden'>
              <h6 className='mr-2 font-[600]'>{page == 1 ? data?.datas?.length > 0 ? 1 : 0 : (page - 1) * data?.pagination?.limit} - {data?.pagination?.limit} of {data?.pagination?.total}  </h6>

              <div>
                <IconButton onClick={() => { page > 1 ? setpage(page - 1) : console.log('') }}><FiChevronLeft className={`${page === 1 ? 'opacity-50' : 'opacity-100'}`} size={16} /></IconButton>
                <IconButton onClick={() => { page < data?.pagination?.totalPages ? setpage(page + 1) : console.log('') }}><FiChevronRight className={`${(data?.pagination?.totalPages === page || data?.datas?.length === 0) ? 'opacity-50 ' : 'opacity-100'}`} size={16} /></IconButton>
              </div>
              </div>

            <div className='flex flex-wrap items-center text-[12px]'>

              <div className='hidden md:flex items-center'>
              {/* <AiOutlineFileExcel onClick={() => downloaddata()} size={24} className='mx-2 bg-gray-200 p-1.5' /> */}

              <h6 className='mr-2 font-[600]'>{page == 1 ? data?.datas?.length > 0 ? 1 : 0 : (page - 1) * data?.pagination?.limit} - {data?.pagination?.limit} of {data?.pagination?.total}  </h6>

              <div>
                <IconButton onClick={() => { page > 1 ? setpage(page - 1) : console.log('') }}><FiChevronLeft className={`${page === 1 ? 'opacity-50' : 'opacity-100'}`} size={16} /></IconButton>
                <IconButton onClick={() => { page < data?.pagination?.totalPages ? setpage(page + 1) : console.log('') }}><FiChevronRight className={`${(data?.pagination?.totalPages === page || data?.datas?.length === 0) ? 'opacity-50 ' : 'opacity-100'}`} size={16} /></IconButton>
              </div>
              </div>

              <DatePicker size='small' style={{ fontSize: '11px' }} ampm={false} placeholder='From Date' className='text-[11px] py-[2.6px]  w-28 border-slate-300 mr-2' value={search?.from_date} onChange={(v, v1) => { console.log('v na', new Date(v).toLocaleDateString()); setsearch({ ...search, from_date: v, from_date1: v1 }) }} />

              <DatePicker size='small' style={{ fontSize: '11px' }} ampm={false} placeholder='To Date' className='text-[11px] py-[2.6px]  w-28 border-slate-300 mr-2' value={search?.to_date} onChange={(v, v1) => { console.log('v na', new Date(v).toLocaleDateString()); setsearch({ ...search, to_date: v, to_date1: v1 }) }} />

            

              <div className='mr-2 mt-1 md:mt-0'>
                <input id="search_text" placeholder='Search text' type='text' value={search.text} onChange={(e) => setsearch({ ...search, text: e.target.value })} className='border py-[3px] focus:ring-0 focus:outline-0 text-[14px]  w-[100px] px-1 rounded-md border-slate-300' />
              </div>
              <div className='mr-2 mt-1 md:mt-0'>
                <ButtonOutlinedAutoWidth btnName="Apply Filter" onClick={() => applyFilter()} />
              </div>
              <div className='mr-2 mt-1 md:mt-0'>
                <ButtonOutlinedAutoWidth btnName="Reset Filter" onClick={() => resetfilter()} />
              </div>
              {/* {(['vehicle_admin','vehicle_creator','admin']?.filter((f)=>roles?.includes(f))?.length > 0 && */}
              {/* )} */}
            </div>
          </div>

           <div className='md:h-[90vh] mb-[50px] md:overflow-hidden'>
          
                      {data?.datas?.length === 0 &&
                        <div className='grid place-items-center mt-20  items-center justify-center'>
                          <img src={'https://fidecrmfiles.s3.amazonaws.com/NoDataFound1.png'} className='w-40 h-40 object-contain' />
                          <h6 className='font-bold text-[14px] -mt-10'>No data found</h6>
                          <h6 className='font-[500] w-[70%] text-center text-slate-700 text-[12.5px] -mt-2'>Oops we couldn't find any data based on your current stage please add the data to see list here.</h6>
                        </div>}
          
                      <div className='w-[100%] overflow-hidden'>
                        {data?.datas?.length > 0 &&
                          <div className='md:max-h-[85vh] mt-4 md:overflow-auto border-t border-l border-r'>
                            <div className='sticky top-0 z-50 flex w-max md:w-[100%]  bg-white py-[-5px] border-b border-slate-200 relative'>
                              <h6 className='top-0 bg-white z-50 text-[12px] min-w-[50px] w-[50px]  md:min-w-[50px]  md:w-[50px]  px-2 py-1 font-[600] text-slate-800 border-r flex items-center justify-center'>Sl No</h6>
                              <h6 className='sticky top-0 z-50  text-[12px]  min-w-[180px] w-[180px]  md:min-w-[180px]  md:w-[180px]  px-2 py-1 font-[600] bg-[#2a297e] text-white border-r'>Client Name</h6>
                              <h6 className='sticky top-0 z-50  text-[12px]  min-w-[160px] w-[160px]  md:min-w-[160px]  md:w-[160px]  px-2 py-1 font-[600] text-slate-800 border-r'>Mobile </h6>
                              <h6 className='sticky top-0 z-50  text-[12px]  min-w-[160px] w-[160px]  md:min-w-[160px]  md:w-[160px]  px-2 py-1 font-[600] text-black bg-[#de9f19] border-r'>Points</h6>
                              <h6 className='sticky top-0 z-50  text-[12px] min-w-[300px] w-[300px]  md:min-w-[300px]  md:w-[300px]  px-2 py-1 font-[600] text-slate-800 border-r'>Remarks</h6>
                              <h6 className='sticky top-0 z-50  text-[12px] min-w-[120px] w-[120px]  md:min-w-[120px]  md:w-[120px]  px-2 py-1 font-[600] text-slate-800 border-r'>Created At</h6>
                              {/* <h6 className='sticky top-0 z-50  text-[12px] min-w-[80px] w-[80px]  md:min-w-[80px]  md:w-[80px]  px-2 py-1 font-[600] text-slate-800 '>Actions</h6> */}
                            </div>
                            {data?.datas?.map((d, i) => (
                              <div className='flex w-max md:w-[100%] text-[11px]  bg-white py-[-5px] border-b border-slate-200 relative'>
                                <h6 className='bg-white text-[12px] min-w-[50px] w-[50px]  md:min-w-[50px]  md:w-[50px]   px-2 py-1 font-[500] border-r flex items-start justify-center'>{(page > 1 ? i + 1 + (data?.pagination?.limit * (page - 1)) : i + 1)}</h6>
                                <h6 className=' text-[11px] break-word min-w-[180px] w-[180px]  md:min-w-[180px] md:w-[180px] bg-[#2a297e] text-white px-2 py-1 border-r'>
                                  <span className='font-normal'>{d?.customer?.name}</span>
                                
                                </h6>
                                <h6 className=' text-[12px] break-word min-w-[160px] w-[160px]  md:min-w-[160px]  md:w-[160px] px-2 py-1 font-[500] border-r'>
                                  <span className='font-normal'>{d?.customer?.mobile}</span><br></br>
                                </h6>
                                <h6 className=' text-[12px] break-all min-w-[160px] w-[160px]  md:min-w-[160px]  md:w-[160px]  px-2 py-1 font-[500] text-black bg-[#de9f19] border-r'>
                                 {d?.points}
                                </h6>
                                <h6 className=' text-[11px] break-word min-w-[300px] w-[300px]  md:min-w-[300px]  md:w-[300px]  px-2 py-1  border-r'>
                                  {d?.summary}
                                </h6>
                              
                                <h6 className='  break-word min-w-[120px] w-[120px]  md:min-w-[120px]  md:w-[120px]  px-2 py-1 font-[500] border-r'>{moment(d?.createdAt)?.format('LL')}</h6>
                                {/* <h6 className='flex items-start  min-w-[80px] w-[80px]  md:min-w-[80px]  md:w-[80px] px-2 py-1 font-[500] '>
                                  <AiOutlineEdit onClick={() => navigator('edit', { state: d })} className='mr-2' />
                                </h6> */}
                              </div>))}
                          </div>}
                      </div>
          
                    </div>
       
         



        </div>
      </div>
    </div>
  )
}

export default LeaderBoardTransaction